import { render, staticRenderFns } from "./NewCopyIcon.vue?vue&type=template&id=40b588a8&scoped=true&"
import script from "./NewCopyIcon.vue?vue&type=script&lang=js&"
export * from "./NewCopyIcon.vue?vue&type=script&lang=js&"
import style0 from "./NewCopyIcon.vue?vue&type=style&index=0&id=40b588a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b588a8",
  null
  
)

export default component.exports